module.exports = __webpack_public_path__ + "static/media/main32.665322a4.png";